/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Open_LinkInputs */

const en_coaching_open_link = /** @type {(inputs: Coaching_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open scheduler`)
};

const id_coaching_open_link = /** @type {(inputs: Coaching_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka penjadwal`)
};

/**
* | output |
* | --- |
* | "Open scheduler" |
*
* @param {Coaching_Open_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_open_link = /** @type {((inputs?: Coaching_Open_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Open_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_open_link(inputs)
	return en_coaching_open_link(inputs)
});